import S3 from 'aws-sdk/clients/s3'
import { v4 as uuid } from 'uuid'

import { API } from '~lib/constants'
import { readFileAsBuffer } from '~lib/utils/files'

type UploadOptions = { pathname?: string }

export const uploadToS3 = async (file: File, options = {} as UploadOptions) => {
  let { pathname } = options

  if (!pathname) {
    pathname = `${uuid()}/${uuid()}/${file.name}`
  }

  const buffer = await readFileAsBuffer(file)
  const response = await fetch(`${API.AWS_UPLOAD_FILE}?pathname=${pathname}`)
  const { error, token, region, bucket, key } = await response.json()

  if (error) {
    console.error(error)
    throw error
  } else {
    const { AccessKeyId, SecretAccessKey, SessionToken } = token.Credentials
    // FIXME Move to backend
    const s3 = new S3({
      credentials: {
        accessKeyId: AccessKeyId,
        secretAccessKey: SecretAccessKey,
        sessionToken: SessionToken,
      },
      region,
    })

    const params = {
      ACL: 'public-read',
      Bucket: bucket,
      Key: key,
      Body: buffer,
      CacheControl: 'max-age=630720000, public',
      ContentType: file.type,
    }

    const uploadResult = await s3.upload(params).promise()

    return uploadResult.Location
  }
}

export async function downloadFromS3(url: string, returnType?: 'url'): Promise<string | null>
export async function downloadFromS3(url: string, returnType?: 'file'): Promise<File | null>
export async function downloadFromS3(url: string, returnType = 'url') {
  try {
    const key = url.replace(/.+s3.amazonaws.com\//, '')

    const request = await fetch(`${API.AWS_DOWNLOAD_FILE}?key=${key}`)
    const response = await request.json()

    const buffer = Buffer.from(response.Body, 'binary')
    const blob = new Blob([buffer], { type: response.ContentType })

    if (returnType === 'file') {
      const fileName = url.split('/').pop()
      return new File([blob], fileName || 'some', { type: blob.type })
    }

    if (returnType === 'url') {
      return URL.createObjectURL(blob)
    }

    return null
  } catch {
    return null
  }
}
